<template>
  <div class="announcement oc-hide">
    <div class="container row justify-content-center valign-wrapper no-padding">
      <div class="announcement__text">
        <img
          :alt="$t('helpUkraineDescr')"
          src="/img/navigation/ukraine-flag.svg"
          class="icon"
          height="18"
          width="18"
        />
        <NuxtLink
          class="clear-link semibold"
          to="/page/help-ukraine-126"
          target="_blank"
          :title="$t('helpUkraineDescr')"
        >
          {{ $t('helpUkraine') }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>

<style lang="scss">
.announcement {
  position: relative;
  flex: 0 0 auto;
  width: 100%;
  height: 40px;
  padding: .375rem 1rem;
  line-height: 1.5;
  background: -webkit-gradient(linear, left top, left bottom, color-stop(50%, #005bbb), color-stop(50%, #ffd500));
  background: linear-gradient(to bottom, #005bbb 50%, #ffd500 50%);
  &__text {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    max-width: max-content;
    padding: .375rem 1rem !important;
    margin: 0;
    font-size: 14px;
    text-align: center;
    background: rgba(255,255,255,.95);
    border-radius: 3px;
    transform: translate(-50%, -50%);
    img.icon {
      display: inline-block;
      width: 18px;
      height: 18px;
      padding: 0;
      margin-right: .25rem;
      vertical-align: middle;
    }
  }
}
</style>
